// Constants for different requests for current reducer
export default {
  noteTypes: 'NOTE_TYPES',
};
